var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderIconDarkMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 18,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0832 5.28173C33.9395 6.2302 33.0828 7.27716 31.4427 7.27716H25.5089L26.1079 3.31737H32.0386C33.6787 3.31737 34.2246 4.33478 34.0832 5.28173ZM25.0129 10.5635H29.8995L32.2534 16.2505C32.4814 16.827 32.9852 17.1975 33.8919 17.1975C35.0415 17.1975 35.9732 16.352 36.1263 15.3354C36.1763 14.9967 36.1232 14.6589 35.9873 14.3892L34.1762 9.98848C36.6113 9.10743 37.8835 7.37867 38.1943 5.31279C38.6387 2.37269 36.9026 0 31.9129 0H24.5147C23.3619 0 22.2819 0.912864 22.1147 2.03027L20.1303 15.1679C19.9631 16.2831 20.7675 17.1975 21.9195 17.1975C23.0722 17.1975 24.1539 16.2831 24.321 15.1679L25.0129 10.5635Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.886 7.5921H9.4441C8.47568 7.5921 7.57514 8.35338 7.43229 9.29121C7.28943 10.2298 7.96267 10.9911 8.9303 10.9911H15.3714C16.343 10.9911 17.2427 10.2298 17.3832 9.29121C17.5261 8.35338 16.8544 7.5921 15.886 7.5921ZM17.002 0.193375H3.02825C2.06062 0.193375 1.16087 0.956177 1.0188 1.89478C0.876738 2.8349 1.54997 3.59694 2.5176 3.59694H16.4921C17.4598 3.59694 18.3579 2.8349 18.5008 1.89478C18.6397 0.956177 17.9712 0.193375 17.002 0.193375Z",
    fill: "#73EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIconDarkMob);
export default __webpack_public_path__ + "static/media/header_icon_dark_mob.dee1b058b5f393f50dfbaf9aeb458cfd.svg";
export { ForwardRef as ReactComponent };